import dayjs from '@/services/date'
import getMonthsBetween from '@/utils/get-months-between'
import TransitionName from '@/shared/constants/core/TransitionName'

export const AvailabilityState = Object.freeze({
  Empty: 'empty',
  Header: 'header',
  Available: 'available',
  Unavailable: 'unavailable',
})

export const TransitionTypes = Object.freeze({
  SelectEarlierMonth: 'selectEarlierMonth',
  SelectLaterMonth: 'selectLaterMonth',
  GoToPreviousMonth: 'goToPreviousMonth',
  GoToNextMonth: 'goToNextMonth',
  Default: 'default',
})

const {
  slideLeft,
  slideRight,
  fadeCycleDown,
  fadeCycleUp,
  fadeUp,
} = TransitionName

const {
  SelectEarlierMonth,
  SelectLaterMonth,
  GoToPreviousMonth,
  GoToNextMonth,
  Default,
} = TransitionTypes

export const Transitions = Object.freeze({
  [GoToNextMonth]: slideLeft,
  [GoToPreviousMonth]: slideRight,
  [SelectLaterMonth]: fadeCycleUp,
  [SelectEarlierMonth]: fadeCycleDown,
  [Default]: fadeUp,
})

export function createSelectableMonths() {
  const firstSelectableMonth = dayjs().startOf('month')

  // Availability limited to 12-month range starting from the current month
  const availabilityRange = getMonthsBetween(
    firstSelectableMonth,
    firstSelectableMonth.add(11, 'month')
  )

  const items = availabilityRange.map((month, index, months) => ({
    value: month.month(),
    date: month,
    label: month.format('MMMM YYYY'),
    isFirst: index === 0,
    isLast: index === months.length - 1,
  }))

  return {
    firstMonth: firstSelectableMonth.month(),
    items,
    monthsByKey: Object.fromEntries(items.map((month) => [month.value, month])),
  }
}
